
import { NgModule } from '@angular/core';

import { DeliveryEditProvider } from './delivery-edit.provider';
import { DeliveryListProvider } from './delivery-list.provider';

export * from './delivery-edit.provider';
export * from './delivery-list.provider';

export {
  DeliveryListProvider,
  DeliveryEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    DeliveryEditProvider,
    DeliveryListProvider
  ]
})
export class DeliveryBackendModule { }
